export default {
  props: {
    instance: {
      type: Object,
      required: true,
    },
  },
};
